export class OnboardAdditionalAzureAppsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "customerTenantId",
            "baseName": "customerTenantId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "dataAccessAppId",
            "baseName": "dataAccessAppId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "dataAccessServicePrincipalId",
            "baseName": "dataAccessServicePrincipalId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "dataAccessAppSecretUrl",
            "baseName": "dataAccessAppSecretUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "dataAccessFederatedMiResourceId",
            "baseName": "dataAccessFederatedMiResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "managementAppId",
            "baseName": "managementAppId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "managementServicePrincipalId",
            "baseName": "managementServicePrincipalId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "managementAppSecretUrl",
            "baseName": "managementAppSecretUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "dataAccessAppDisplayName",
            "baseName": "dataAccessAppDisplayName",
            "type": "string",
            "format": ""
        },
        {
            "name": "managementAppDisplayName",
            "baseName": "managementAppDisplayName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OnboardAdditionalAzureAppsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
